import { v4 as uuidv4 } from "uuid";
import { LangChainMessage } from "@assistant-ui/react-langgraph";
import { AppendMessage, ThreadMessage } from "@assistant-ui/react";

export const convertAssistantMessage = (
  message: ThreadMessage | AppendMessage,
): LangChainMessage => {
  switch (message.role) {
    case "system":
      return { id: uuidv4(), type: "system", content: message.content[0].text };
    case "user": {
      if (!message.content[0] || !("text" in message.content[0]))
        return { id: uuidv4(), type: "human", content: "" };

      return { id: uuidv4(), type: "human", content: message.content[0].text };
    }
    case "assistant": {
      if (!message.content[0] || !("text" in message.content[0]))
        return { id: uuidv4(), type: "ai", content: "" };

      return { id: uuidv4(), type: "ai", content: message.content[0].text };
    }
    default:
      return { id: uuidv4(), type: "system", content: "" };
  }
};

export type NormalizedSource = {
  title: string;
  url: string;
  site?: string;
  date?: string;
  imageUrl?: string;
};

type RawThumb = { href?: string };
type RawImageLinks = { thumbnail?: RawThumb[]; icon?: RawThumb[]; logo?: RawThumb[] };
type RawImage = { url?: string; links?: RawImageLinks; meta?: { site?: string; date?: string; title?: string } };
type RawSearchResult = { title?: string; url: string; date?: string; image?: RawImage };

function getThumb(links?: RawImageLinks): string | undefined {
  const pick = (arr?: RawThumb[]) => arr?.find(t => !!t?.href)?.href;
  return pick(links?.thumbnail) || pick(links?.logo) || pick(links?.icon);
}

export function parseWebResult(raw: string): NormalizedSource[] {
  let obj: any;
  try {
    obj = JSON.parse(raw);
  } catch {
    return []; 
  }

  const results: RawSearchResult[] = obj.search_results ?? [];

  return results
    .filter((rawResult: RawSearchResult) => typeof rawResult?.url === "string")
    .map((rawResult) => {
      const imageUrl =
        getThumb(rawResult.image?.links) ||
        rawResult.image?.url;
      return {
        title: rawResult.title || rawResult.image?.meta?.title || new URL(rawResult.url).hostname,
        url: rawResult.url,
        site: rawResult.image?.meta?.site,
        date: rawResult.image?.meta?.date || rawResult.date,
        imageUrl,
      };
    });
}